/**
 * Shared guide overlays for the wall editing gestures (selection shape
 * handles + hover drag control): the own-axis extension line and the height
 * alignment line. Pure render — the drag logic lives in the layers.
 */
import { Line, Text } from '@react-three/drei';
import { AxisGuideState, HeightGuideState, GUIDE_COLOR, SNAP_COLOR } from '../utils/wallHandlePreview';

/** Own-axis extension guide (endpoint drags): the run's line extended past
 *  both ends; orange while the endpoint is locked onto it, blue while free. */
export function WallAxisGuide({ guide }: { guide: AxisGuideState }) {
    return (
        <Line
            points={guide.points}
            color={guide.snapped ? SNAP_COLOR : GUIDE_COLOR}
            lineWidth={1.5}
            dashed
            dashSize={0.18}
            gapSize={0.12}
            transparent
            opacity={guide.snapped ? 1 : 0.75}
        />
    );
}

/** Height alignment guide (top drags): horizontal line at the candidate
 *  elevation with its value labeled. */
export function WallHeightGuide({ guide }: { guide: HeightGuideState }) {
    return (
        <group>
            <Line
                points={[guide.from, guide.to]}
                color={SNAP_COLOR}
                lineWidth={1.5}
                dashed
                dashSize={0.18}
                gapSize={0.12}
            />
            <Text
                position={[
                    (guide.from[0] + guide.to[0]) / 2,
                    (guide.from[1] + guide.to[1]) / 2,
                    guide.z + 0.18,
                ]}
                fontSize={0.2}
                color={SNAP_COLOR}
                anchorX="center"
                anchorY="bottom"
                outlineWidth={0.012}
                outlineColor="#000000"
            >
                {`${guide.z.toFixed(2)} m`}
            </Text>
        </group>
    );
}
